/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TextBulletNumbersIcon16Light } from './TextBulletNumbersIcon16Light';
import { TextBulletNumbersIcon16Regular } from './TextBulletNumbersIcon16Regular';
import { TextBulletNumbersIcon16Solid } from './TextBulletNumbersIcon16Solid';
import { TextBulletNumbersIcon20Light } from './TextBulletNumbersIcon20Light';
import { TextBulletNumbersIcon20Regular } from './TextBulletNumbersIcon20Regular';
import { TextBulletNumbersIcon20Solid } from './TextBulletNumbersIcon20Solid';
import { TextBulletNumbersIcon24Regular } from './TextBulletNumbersIcon24Regular';
import { TextBulletNumbersIcon24Solid } from './TextBulletNumbersIcon24Solid';
import { TextBulletNumbersIcon32Regular } from './TextBulletNumbersIcon32Regular';
import { TextBulletNumbersIcon64Regular } from './TextBulletNumbersIcon64Regular';
var sizes = {
    16: {
        light: TextBulletNumbersIcon16Light,
        regular: TextBulletNumbersIcon16Regular,
        solid: TextBulletNumbersIcon16Solid,
    },
    20: {
        light: TextBulletNumbersIcon20Light,
        regular: TextBulletNumbersIcon20Regular,
        solid: TextBulletNumbersIcon20Solid,
    },
    24: {
        regular: TextBulletNumbersIcon24Regular,
        solid: TextBulletNumbersIcon24Solid,
    },
    32: {
        regular: TextBulletNumbersIcon32Regular,
    },
    64: {
        regular: TextBulletNumbersIcon64Regular,
    },
};
export var TextBulletNumbersIcon = forwardRef('TextBulletNumbersIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
